<!-- Error Banner -->
<div *ngIf="errorMessage" class="error-banner">
  <i class="fas fa-exclamation-circle"></i>
  <span>{{ errorMessage }}</span>
  <button type="button" class="error-close" (click)="clearError()">
    <i class="fas fa-times"></i>
  </button>
</div>

<form [formGroup]="scrapForm" (ngSubmit)="onSubmit()" class="create-item-form">
  <div class="form-grid">

    <!-- Category -->
    <div class="form-group">
      <label class="form-label">Category <span class="required">*</span></label>
      <select formControlName="categoryId" class="form-input"
        [class.input-error]="scrapForm.get('categoryId')?.invalid && scrapForm.get('categoryId')?.touched">
        <option [value]="null">{{ isLoadingCategories ? 'Loading...' : 'Select Category' }}</option>
        <option *ngFor="let cat of categories" [value]="cat.id">{{ cat.name }}</option>
      </select>
      <span class="field-hint" *ngIf="isLoadingCategories">
        <i class="fas fa-spinner fa-spin"></i> Loading categories...
      </span>
    </div>

    <!-- Name -->
    <div class="form-group">
      <label class="form-label">Name <span class="required">*</span></label>
      <input type="text" formControlName="name" class="form-input"
        [class.input-error]="scrapForm.get('name')?.invalid && scrapForm.get('name')?.touched"
        placeholder="e.g. Iron Rod, Copper Wire">
    </div>

    <!-- Unit -->
    <div class="form-group">
      <label class="form-label">Unit <span class="required">*</span></label>
      <select formControlName="unit" class="form-input"
        [class.input-error]="scrapForm.get('unit')?.invalid && scrapForm.get('unit')?.touched">
        <option value="">Select Unit</option>
        <option value="Kg">Kg</option>
        <option value="Pc">Pc</option>
      </select>
    </div>

    <!-- Description -->
    <div class="form-group">
      <label class="form-label">Description <span class="required">*</span></label>
      <input type="text" formControlName="description" class="form-input"
        [class.input-error]="scrapForm.get('description')?.invalid && scrapForm.get('description')?.touched"
        placeholder="Short description of the item">
    </div>

    <!-- Regular Price -->
    <div class="form-group">
      <label class="form-label">Regular Price (₹) <span class="required">*</span></label>
      <input type="number" formControlName="regularPrice" class="form-input" min="0" step="0.01" placeholder="0.00"
        [class.input-error]="scrapForm.get('regularPrice')?.invalid && scrapForm.get('regularPrice')?.touched">
    </div>

    <!-- Special Price -->
    <div class="form-group">
      <label class="form-label">Special Price (₹) <span class="required">*</span></label>
      <input type="number" formControlName="specialPrice" class="form-input" min="0" step="0.01" placeholder="0.00"
        [class.input-error]="scrapForm.get('specialPrice')?.invalid && scrapForm.get('specialPrice')?.touched">
    </div>

    <!-- Dealer Percentage -->
    <div class="form-group">
      <label class="form-label">Dealer Percentage (%)</label>
      <input type="number" formControlName="dealerPercentage" class="form-input" min="0" step="0.01" placeholder="0.00">
    </div>

    <!-- Is Visible to Customer -->
    <div class="form-group toggle-group">
      <label class="form-label">Visible to Customer?</label>
      <label class="toggle-switch">
        <input type="checkbox" formControlName="isVisibleToCustomer">
        <span class="toggle-slider"></span>
      </label>
      <span class="toggle-hint">{{ scrapForm.get('isVisibleToCustomer')?.value ? 'Yes' : 'No' }}</span>
    </div>

    <!-- Is Scrap -->
    <div class="form-group toggle-group">
      <label class="form-label">Is Scrap?</label>
      <label class="toggle-switch">
        <input type="checkbox" formControlName="isScrap">
        <span class="toggle-slider"></span>
      </label>
      <span class="toggle-hint">{{ scrapForm.get('isScrap')?.value ? 'Yes — scrap material' : 'No — non-scrap' }}</span>
    </div>

  </div>

  <!-- Alternative Names (full width) -->
  <div class="form-group alt-names-group">
    <label class="form-label">Alternative Names</label>
    <div class="alt-names-row">
      <input type="text" [(ngModel)]="newAlternativeName" [ngModelOptions]="{standalone: true}"
        (keydown.enter)="addAlternativeName($event)" class="form-input"
        placeholder="Type a name and press Enter or click Add">
      <button type="button" class="btn-add" (click)="addAlternativeName()">
        <i class="fas fa-plus"></i> Add
      </button>
    </div>
    <div class="alt-tags" *ngIf="alternativeNames.length > 0">
      <span *ngFor="let name of alternativeNames; let i = index" class="alt-tag">
        {{ name }}
        <button type="button" class="alt-tag-remove" (click)="removeAlternativeName(i)">
          <i class="fas fa-times"></i>
        </button>
      </span>
    </div>
    <p class="field-hint">These names help customers search for this item using different terms.</p>
  </div>

  <!-- Actions -->
  <div class="form-actions">
    <button type="submit" class="btn-submit" [disabled]="!scrapForm.valid || isSubmitting">
      <i class="fas" [ngClass]="isSubmitting ? 'fa-spinner fa-spin' : 'fa-plus-circle'"></i>
      {{ isSubmitting ? 'Creating...' : 'Create Item' }}
    </button>
  </div>
</form>
